import { Outlet, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  chooseModalEmailVerify,
  chooseModalLogin,
  setSelectedRoute,
} from "../States/authModalsSlice";
import useAuthentication from "../States/onAuthStateChange";
import { Box, CircularProgress } from "@mui/material";
import { useLocation } from "react-router-dom";
import { useEffect } from "react";
import { fetchUserData } from "../States/userDataSlice";
import paths from "./paths";

export const PrivateOutlet = (props) => {
  const dispatch = useDispatch();
  const { children } = props;
  const navigate = useNavigate();
  const location = useLocation();
  const { user, userId, loading } = useAuthentication();
  const userData = useSelector((state) => state.userData.data);
  const email_verified = userData?.email_verified;
  const onboarding_complete = userData?.educator?.onboarding_complete
  const isUserDataReady = userData !== undefined && typeof email_verified === "boolean";
  useEffect(
    () => {
      if (userId) {
        dispatch(fetchUserData(userId));
      }
    },
    [dispatch, userId])

  if (loading || (user && !isUserDataReady)) {
    return (
      <Box
        display="flex"
        height="100vh"
        justifyContent="center"
        alignItems="center"
      >
        <CircularProgress />
      </Box>
    );
  }
  if (!user) {
    dispatch(chooseModalLogin());
    return navigate(paths.home.path);
  } else if (!email_verified && location.pathname === paths.dashboardPage.path) {
    dispatch(setSelectedRoute(location.pathname));
    dispatch(chooseModalEmailVerify());
    return navigate(paths.home.path);
  } else if ((email_verified && !userData?.is_educator) && location.pathname === paths.createCoursePage.path) {
    return navigate(paths.dashboardPage.path);
  } else if (userData && userData?.is_educator && !onboarding_complete && location.pathname === paths.dashboardPage.path) {
    return navigate(paths.onboardingPage.path);
  }
  else {
    return (
      <>
        {children}
        <Outlet />
      </>
    );
  }
};

export const PrivateOutletEdu = (props) => {

  const { children } = props;
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const { user, userId } = useAuthentication();
  const loading = useSelector((state) => state.userData.loading);
  const userData = useSelector((state) => state.userData.data);
  const email_verified = userData?.email_verified;
  const isEducator = userData?.is_educator
  const onboardingComplete = userData?.educator?.onboarding_complete;
  const isUserDataLoaded = userData !== undefined && typeof email_verified === "boolean"
  useEffect(() => {
    if (!loading && user) {
      if (!userData) {
        return
      }
      if (!isEducator && location.pathname === paths.onboardingPage.path) {
        navigate(paths.home.path);
      }
      if (isEducator && onboardingComplete && location.pathname === paths.onboardingPage.path) {
        navigate(paths.dashboardPage.path);
      }
    }
  }, [loading, user, userData, location.pathname, isEducator, navigate, email_verified, onboardingComplete]);
  useEffect(
    () => {
      if (userId) {
        dispatch(fetchUserData(userId));
      }
    },
    [dispatch, userId])
  if (loading || (user && !isUserDataLoaded)) {
    return (
      <Box
        display="flex"
        height="100vh"
        justifyContent="center"
        alignItems="center"
      >
        <CircularProgress />
      </Box>
    );
    }
    return (
      <>
        {children}
        <Outlet />
      </>
    );
};
